var _stop, _stop2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgQuestion(props) {
  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73 12.182c0-5.576 4.495-10.08 10.06-10.08s10.06 4.504 10.06 10.08c0 5.575-4.495 10.08-10.06 10.08-2.057 0-3.957-.596-5.675-1.753l-4.403 1.872 1.85-4.368-.004-.031-.012-.014a10.307 10.307 0 01-1.814-5.532l-.003-.254zm10.076 3.176c-.204 0-.407-.204-.407-.408v-2.344c0-.204.204-.408.407-.408 1.22 0 2.238-1.02 2.238-2.243 0-1.223-1.017-2.243-2.238-2.243-1.22 0-2.238 1.02-2.238 2.243 0 .204-.204.408-.407.408-.204 0-.407-.204-.407-.408 0-1.733 1.424-3.16 3.154-3.16s3.154 1.427 3.154 3.16c0 1.53-1.12 2.854-2.646 3.058v1.937c-.203.204-.407.408-.61.408zm.98 1.742a.9.9 0 11-1.8 0 .9.9 0 011.8 0z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 12.586,
    y1: 15.881,
    x2: 11.676,
    y2: 17.314,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  })))));
}

export default SvgQuestion;